import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate, useParams } from "react-router";
import styled from "styled-components";
import { Header } from "../components/Header";
import TrackUploadContent from "./components/ТrackUploadContent";
import { useRelease } from "../hooks/useRelease";
import { ProgressSpinner } from "primereact/progressspinner";
import { runDraftSaveIfNeeded } from "../draftSaveGuard";

interface AudioFile {
  file: File;
  url: string;
  id: string;
}

interface TrackUploadProps {
  audioFiles: AudioFile[];
  setAudioFiles: React.Dispatch<React.SetStateAction<AudioFile[]>>;
  serverAudioAvailable?: boolean;
  onLoadServerAudio?: () => void;
  replaceMode?: boolean;
  onStartReplace?: () => void;
  onCancelReplace?: () => void;
  audioPreviewLoading?: boolean;
  isTrackInfoStep?: boolean;
  startTime: string;
  setStartTime: (value: string) => void
  setFormState: React.Dispatch<React.SetStateAction<{ ai_generated: boolean; explicit_content: boolean; instrumental_music: boolean; }>>;
  formState: FormState,
  loading: boolean
  saving?: boolean;
}
interface FormState {
  ai_generated: boolean ;
  explicit_content:  boolean;
  instrumental_music: boolean;
}
export const TrackUpload = ({
  audioFiles,
  setAudioFiles,
  serverAudioAvailable,
  onLoadServerAudio,
  replaceMode,
  onStartReplace,
  onCancelReplace,
  audioPreviewLoading,
  isTrackInfoStep,
  startTime,
  setStartTime,
  setFormState,
  formState,
  loading,
  saving
}: TrackUploadProps) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const onBack = () => {
    (async () => {
      try {
        await runDraftSaveIfNeeded();
        navigate(`/releases/new-release/${id}?step=release-info`);
      } catch (err) {
        // Keep user on the page if save failed (avoid losing edits)
        console.error("[TrackUpload] draft save failed; navigation cancelled", err);
      }
    })();
  };

  return (
    <Container>
      {saving && (
        <BlockLoadingOverlay>
          <ProgressSpinner style={{ width: "48px", height: "48px" }} />
        </BlockLoadingOverlay>
      )}
      <Header
        title={
          <FormattedMessage
            id="NewRelease.TrackUpload.Title"
            defaultMessage="Track upload (Step 4/6)"
          />
        }
        breadcrumbsText={
          <FormattedMessage
            id="NewRelease.TrackUpload.Breadcrumbs"
            defaultMessage="Release information"
          />
        }
        onBack={onBack}
      />
      <TrackUploadContent
        audioFiles={audioFiles}
        setAudioFiles={setAudioFiles}
        serverAudioAvailable={serverAudioAvailable}
        onLoadServerAudio={onLoadServerAudio}
        replaceMode={replaceMode}
        onStartReplace={onStartReplace}
        onCancelReplace={onCancelReplace}
        audioPreviewLoading={audioPreviewLoading}
        isTrackInfoStep={isTrackInfoStep}
        startTime={startTime}
        setStartTime={setStartTime}
        setFormState={setFormState}
        formState={formState}
        loading={loading}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 38px 20px 30px;
  height: 100%;
  position: relative;
`;

const BlockLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  border-radius: 14px;
`;
